import { BookOpenIcon, ClipboardCheckIcon, ClipboardListIcon, PresentationIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '150 Attività e Sfide su Petrolio e Gas per la Classe',
    description: 'Attività pronte organizzate per tema, con obiettivo, durata, materiali e domande guida.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Banca di Verifiche e Valutazioni su Petrolio e Gas',
    description: 'Verifiche per unità con soluzioni complete, griglie e rubriche di valutazione.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: "100 Casi di Studio e Scenari dell'Industria del Petrolio e del Gas",
    description: 'Situazioni realistiche del settore da analizzare e discutere in classe.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: 'Dizionario del Docente di Petrolio e Gas: 200 Concetti Essenziali Spiegati per la Classe',
    description: 'I termini chiave del settore spiegati in modo semplice, pronti da usare a lezione.',
    icon: BookOpenIcon,
  },
  {
    number: '5',
    title: 'Guida del Docente: Strategie Didattiche, Metodi di Discussione e Programmazione',
    description: 'Strategie per insegnare il tema, guidare discussioni equilibrate e programmare le unità.',
    icon: PresentationIcon,
  },
];
